module.exports = __webpack_public_path__ + "static/media/bg.b22b8e44.png";